import dynamic from 'next/dynamic';

const DynamicCookiesManager = dynamic(() => import('@components/CookiesManager'), {
    ssr: false,
});

export default DynamicCookiesManager;
